import React from 'react';
import MUIDataTable from "mui-datatables";

const options = {
  filterType: 'checkbox',
  responsive: "standard",
  selectableRowsHeader: false,
  selectableRows: "none",
  rowsPerPage: 10,
  download: false,
  print: false,
  textLabels: {
    body: {
      noMatch: "Não há resultados correspondentes",
      toolTip: "Ordenar",
      columnHeaderTooltip: column => `Ordenar por  ${column.label}`
    },
    pagination: {
      next: "Próxima Página",
      previous: "Página Anterior",
      rowsPerPage: "Linhas por página:",
      displayRows: "de",
    },
    toolbar: {
      search: "Pesquisar",
      viewColumns: "Visualizar Colunas",
      filterTable: "Filtrar Tabela",
    },
    filter: {
      all: "TODOS",
      title: "FILTROS",
      reset: "RESETAR",
    },
    viewColumns: {
      title: "Mostrar Colunas",
      titleAria: "Mostrar/Esconder Colunas da Tabela",
    },
  }
};

export default class ScheduleTable extends React.Component {

  render() {
    const { columns, data, title } = this.props;
    return (
      <div style={{ marginBottom: "30px" }}>
        <MUIDataTable
          title={title}
          data={data}
          columns={columns}
          options={options}
        />
      </div>
    )
  }

}